import { Row, Column } from 'gatsby-theme-carbon/src/components/Grid';
import img1 from "../../../../src/visuals/design/visual_2_1_eg.png";
import img2 from "../../../../src/visuals/design/visual_2_2_do.png";
import img3 from "../../../../src/visuals/design/visual_2_2_dont.png";
import { withPrefix } from "gatsby";
import ToolkitRequirement from "../../../../src/components/rms_resources/requirements";
import ToolkitReference from "../../../../src/components/rms_resources/references";
import ToolkitTechnique from "../../../../src/components/rms_resources/techniques";
import ToolkitTopic from "../../../../src/components/rms_resources/topics";
import * as React from 'react';
export default {
  Row,
  Column,
  img1,
  img2,
  img3,
  withPrefix,
  ToolkitRequirement,
  ToolkitReference,
  ToolkitTechnique,
  ToolkitTopic,
  React
};